import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import apiClient from '../services/api';

// Aviso persistente de prueba gratuita — antes "Prueba 14 días gratis"
// era solo texto de marketing, sin nada detrás que lo hiciera cumplir.
// Ahora /subscription/current sí calcula días restantes (ver
// core/deps.py get_trial_status en el backend) y este banner avisa
// ANTES de que la prueba venza (últimos 3 días). Una vez vencida, ya no
// hace falta este aviso -- TrialExpiredScreen (ver NotionLayout.js)
// reemplaza toda la página con el bloqueo, así que mostrar el banner
// encima sería redundante.
const TrialBanner = () => {
  const [status, setStatus] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/subscription/current')
      .then((res) => {
        if (!cancelled) setStatus(res.data);
      })
      .catch(() => {
        // Si falla, no mostramos nada — no vale la pena bloquear ni
        // asustar al usuario por un error de red al pedir esto.
      });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  // Ya pagó, ya venció (lo cubre TrialExpiredScreen), o falta más de 3
  // días: nada que avisar todavía.
  if (!status || status.pago || status.trial_expirado) return null;
  if (status.dias_restantes == null || status.dias_restantes > 3) return null;

  // Ya estamos en /subscription — no hace falta el banner empujando a la
  // misma página en la que ya está.
  if (location.pathname === '/subscription') return null;

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        <Button component={RouterLink} to="/subscription" color="inherit" size="small" sx={{ fontWeight: 'bold' }}>
          Ver planes
        </Button>
      }
    >
      {`Te quedan ${status.dias_restantes} ${status.dias_restantes === 1 ? 'día' : 'días'} de prueba gratuita.`}
    </Alert>
  );
};

export default TrialBanner;
